var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.overlays),function(overlay){return _c('GmapGroundOverlay',{key:overlay.image,attrs:{"source":overlay.image,"bounds":overlay.bounds,"opacity":1,"is-shown":overlay.isShown}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }